<script setup lang="ts">
import type { BlockRootContext } from '#layers/block-engine/public';
import { computed } from 'vue';
import PageShellBlank from '#layers/ui-workspace/components/PageShell/Blank.vue';
import PageShellCollectionDetail from '#layers/ui-workspace/components/PageShell/CollectionDetail/CollectionDetail.vue';

const props = defineProps<{
	context: BlockRootContext;
}>();

const Shell = computed(() => {
	switch (props.context.pageType) {
		case 'detail':
			return PageShellCollectionDetail;
		default:
			return PageShellBlank;
	}
});
</script>

<template>
	<Shell :context>
		<slot />
	</Shell>
</template>
